import * as React from 'react';

import { useVoiceboxSchema } from 'bones/components/molecules/Voicebox/context/VoiceboxSchema';
import { useReasoningStepsFromMessage } from 'bones/components/molecules/Voicebox/hooks/useReasoningStepsFromMessage';
import { VoiceboxReasoningSteps } from 'bones/components/molecules/Voicebox/shared/VoiceboxReasoningSteps';
import {
  VoiceboxResponseAction,
  VoiceboxResponseMessage,
} from 'bones/constants/voicebox/message';
import { VoiceboxSettings } from 'bones/constants/voicebox/settings';
import { Accordion } from 'bones/design-system/components/Accordion';

export interface VoiceboxPanelReasoningProps {
  action: VoiceboxResponseAction;
  message: VoiceboxResponseMessage;
  settings: VoiceboxSettings;
}

export const VoiceboxPanelReasoning: React.VFC<VoiceboxPanelReasoningProps> = ({
  action,
  message,
  settings,
}) => {
  const { copy, testIds } = useVoiceboxSchema();
  const reasoningSteps = useReasoningStepsFromMessage({
    action,
    message,
  });

  return reasoningSteps.length ? (
    <Accordion
      className="vb-voicebox-panel-reasoning"
      icon="left"
      label={copy.panel.reasoning.accordion}
      size="md"
      testId={testIds.panel.reasoning.accordion}
    >
      <VoiceboxReasoningSteps
        message={message}
        reasoningSteps={reasoningSteps}
        settings={settings}
      />
    </Accordion>
  ) : null;
};
